import { render, staticRenderFns } from "./ErrorPane.vue?vue&type=template&id=466c1f28&scoped=true&"
import script from "./ErrorPane.vue?vue&type=script&lang=js&"
export * from "./ErrorPane.vue?vue&type=script&lang=js&"
import style0 from "./ErrorPane.vue?vue&type=style&index=0&id=466c1f28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466c1f28",
  null
  
)

export default component.exports